<template>
	<div class="student-place-qcm-container">
		<FullPageLoader v-if="isLoading"/>
		<Loader v-if="isLoadingPrinting"/>
		<div class="input-container">
			<div class="controls-wrapper">
				<button 
					class="submit dark"
					@click="printSubject"
				>
					Imprimer sujet
				</button>
				<button 
					class="submit dark"
					@click="printCorrection"
				>
					Imprimer correction
				</button>
			</div>
			<label>
				<input type="checkbox" v-model="IsAnswersVisible">
				Afficher les reponses
			</label>
			<p>Code anti-triche : <span class="exam__code">{{ examCode }}</span></p>
			<p>L’élève ne pourra reprendre l’examen qu’une fois ce code saisi.</p>
		</div>
		<div class="questions-container">
			<div class="question-container" v-for="question in qcm.questions" :key="question.id">
				<h2> <span v-html="question.question"> </span> <span>({{question.point }} point<span v-if="question.point > 1">s</span>)</span></h2>
				<QCMImage v-if="question.image" :image="question.image" />
				<div class="answers-container">
					<div v-for="answer in question.answers" :key="answer.id">
						<p> <input style="pointer-events: none;" type="checkbox" :checked="answer.is_correct && IsAnswersVisible" > <span v-html="answer.answer"></span></p> 
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getQCMService } from '../../../../../services/qcmServices'
import FullPageLoader from '../../../../Utils/FullPageLoader.vue'
import Loader from '../../../../Loader.vue'
import QCMImage from './QCMImage.vue'
import { generatedQCMPDF } from '../../../../../utils/utils'
import { generateExamCode } from '../../../../Utils/safeExam'
export default {
	components: {
		FullPageLoader,
		QCMImage,
		Loader
	},
	data() {
		return {
			qcm:{},
			questions:[],
			studentAnswers:[],
			isLoading: false,
			isLoadingPrinting: false,
			isPopUpImgVisible: false,
			selectedQuestion: null,
			IsAnswersVisible: false,
		}
	},
	computed: {
		examCode() {
			const { id } = this.$route.params;
			return generateExamCode(Number(id));
		}
	},
	methods: {
		async printSubject() {
			this.isLoadingPrinting = true
			try { await generatedQCMPDF(this.qcm, false) } 
			catch {
				this.$store.state.toast = {
					text: "Erreur lors de l'impression du sujet",
					status: 'error'
				}
			} finally { this.isLoadingPrinting = false }
		},
		async printCorrection() {
			this.isLoadingPrinting = true
			try { await generatedQCMPDF(this.qcm, true) } 
			catch {
				this.$store.state.toast = {
					text: "Erreur lors de l'impression de la correction",
					status: 'error'
				}
			} finally { this.isLoadingPrinting = false }
		},
		showImg(selectedQuestion){
			this.selectedQuestion = selectedQuestion
			this.isPopUpImgVisible = true
		},
		async getQcm() {
			const res = await getQCMService(this.$route.params.id)
			this.qcm = res
			this.$nextTick(() => {
				this.reRender();
			});
		},
		async reRender() {
			if (window.MathJax.typesetPromise) {
				window.MathJax.typesetPromise();
			}
		}
	},
	created() {
		this.isLoading = true
		this.getQcm()
		this.isLoading = false
	
	},
	
}
</script>

<style scoped lang="scss">
@import '../../../../../assets/scss/student-place/qcm.scss';
</style>
